import { Card, CardContent, Grid, InputAdornment } from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import ResetPasswordImg from "../../../assets/images/reset_pass.svg";
import FormValidator from "../../../services/FormValidator";
import CustomInput from "../../components/Input";
import eyeVisible from "../../../assets/icons/eyeVisible.svg";
import eyeHide from "../../../assets/icons/eyeHide.svg";
import queryString from "query-string";
import {
  errorToast,
  successToast,
} from "../../../modules/actions/toast.action";
import { postAuthApi } from "../../../webApis/apiResource";
import { webApiCheck } from "../../../services/commonMethods";
import { REG_EXPS } from "../../../constants";

class ResetPassword extends Component {
  state = {
    isPasswordShown: false,
    isConfirmPasswordShown: false,
  };
  togglePassword = () => {
    const { isPasswordShown } = this.state;
    this.setState({ isPasswordShown: !isPasswordShown });
  };

  toggleConfirmPassword = () => {
    const { isConfirmPasswordShown } = this.state;
    this.setState({ isConfirmPasswordShown: !isConfirmPasswordShown });
  };

  constructor(props) {
    super(props);

    this.state = {
      password: "",
      confirmPassword: "",
    };

    this.rules = {
      password: { required: true, minlength: 8 },
      confirmPassword: { required: true, minlength: 8 },
    };

    this.btns = [
      {
        type: "submit",
        btnProps: {
          method: this.submit,
          text: "Submit",
          variant: "contained",
          classes: {
            root: "login-submit-btn",
            disabled: "disabled-btn disabled-login-btn",
          },
        },
      },
    ];
  }

  handleChange = (ev) => {
    this.setState({
      [ev.target.name]: ev.target.value,
    });
  };

  validatePassword = (password) => {
    let msg = "";
    let digitRegEx = REG_EXPS.ALPHABETS_NUMBERS_AND_SPECIAL_CHARACTERS;
    if (password.search(digitRegEx) === -1) {
      msg = "Password not valid";
    }
    return {
      message: msg,
      validate: msg === "" ? true : false,
    };
  };
  submit = async () => {
    if (this.validatePassword(this.state.password).validate === false) {
      this.props.errorToast({
        data: {
          message: this.validatePassword(this.state.password).message,
        },
      });
    } else if (this.state.password !== this.state.confirmPassword) {
      this.props.errorToast({
        data: {
          message: "Passwords does not match",
        },
      });
    } else {
      const payload = {
        action: "reset_password",
        id: parseInt(this.props.match.params.id),
        token: queryString.parse(this.props.location.search, {
          ignoreQueryPrefix: true,
        }).token,
        new_password: this.state.password,
      };
      const response = await postAuthApi("/user-management", { payload });
      if (webApiCheck(response)) {
        this.props.successToast({
          message: "Password set successfully!",
        });

        setTimeout(() => {
          this.props.history.push("/login");
        }, 4100);
      }
    }
  };

  render() {
    const { isPasswordShown } = this.state;
    const { isConfirmPasswordShown } = this.state;
    return (
      <div className="unauth-content bgNone">
        <Grid container direction="row">
          <Grid item lg={7}>
            <img
              src={ResetPasswordImg}
              className="login-image forgot-password-image"
              alt="Reset Password Image"
            />
          </Grid>
          <Grid item lg={5}>
            <Card className="login-card ">
              <CardContent>
                <FormValidator
                  rules={this.rules}
                  btns={this.btns}
                  data={this.state}
                >
                  <div
                    className="card-title mt-0"
                  >
                    Reset Password
                  </div>
                  <span className="card-subtitle">
                    Your new password must be at least 8 characters long
                    containing at least: 1 character, 1 number and 1 special
                    character
                  </span>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                      margin: "normal",
                      variant: "filled",
                    }}
                    inputProps={{
                      value: this.state.password,
                      onChange: this.handleChange,
                      placeholder: "Password",
                      name: "password",
                      className: "input-login",
                      required: true,
                      type: isPasswordShown ? "text" : "password",
                      InputProps: {
                        endAdornment: (
                          <InputAdornment position="end">
                            <img
                              src={isPasswordShown ? eyeHide : eyeVisible}
                              alt={
                                isPasswordShown
                                  ? `Password Hide Image`
                                  : `Password Visible Image`
                              }
                              className="padlock-icon"
                              onClick={this.togglePassword}
                            />
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                  <CustomInput
                    formControlProps={{
                      fullWidth: true,
                      margin: "normal",
                      variant: "filled",
                    }}
                    inputProps={{
                      value: this.state.confirmPassword,
                      onChange: this.handleChange,
                      placeholder: "Confirm Password",
                      name: "confirmPassword",
                      className: "input-login",
                      required: true,
                      type: isConfirmPasswordShown ? "text" : "password",
                      InputProps: {
                        endAdornment: (
                          <InputAdornment position="end">
                            <img
                              src={
                                isConfirmPasswordShown ? eyeHide : eyeVisible
                              }
                              alt={
                                isConfirmPasswordShown
                                  ? `Password Hide Image`
                                  : `Password Visible Image`
                              }
                              className="padlock-icon"
                              onClick={this.toggleConfirmPassword}
                            />
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                </FormValidator>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  errorToast: (obj) => dispatch(errorToast(obj)),
  successToast: (obj) => dispatch(successToast(obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
